/**
 * Returns URLSearchParams of current url or
 * of provided search params
 * @see https://developer.mozilla.org/de/docs/Web/API/URLSearchParams
 *
 * @param {string|null} params - search parameters (optional)
 * @returns {object}
 */
const getSearchParams = (params = null) => new URLSearchParams(params ? params : window.location.search);

export default getSearchParams;
